import { render, staticRenderFns } from "./SEO.vue?vue&type=template&id=122401d2&scoped=true&"
import script from "./SEO.vue?vue&type=script&lang=js&"
export * from "./SEO.vue?vue&type=script&lang=js&"
import style0 from "./SEO.vue?vue&type=style&index=0&id=122401d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122401d2",
  null
  
)

export default component.exports